import { render, staticRenderFns } from "./BreakfastProductsSection.vue?vue&type=template&id=2a376baa&"
import script from "./BreakfastProductsSection.vue?vue&type=script&lang=js&"
export * from "./BreakfastProductsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports